import { Injectable } from '@angular/core';
import { environment } from 'common/environments/environment';

@Injectable({ providedIn: 'root' })
export class BrandDetectionService {
    getBrand() {
        return environment.brand;
    }
}
